import { TypesTable } from './components/TypesTable'
import { TypesTableProvider } from './CASTypesContext'

const Types: React.FC = () => (
  <TypesTableProvider>
    <TypesTable />
  </TypesTableProvider>
)

export default Types
